import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function FileInput({ placeholder, icon: Icon, className = "", input }: Props) {
  return (
    <label className={classNames(styles.fileInput, className)}>
      {Icon && <Icon />}
      <p className={styles.placeholder}>{placeholder}</p>
      <input
        type="file"
        className={styles.input}
        onChange={({ target }) =>
          target.files &&
          target.files.length > 0 &&
          target.files[0] &&
          input({
            size: target.files[0].size,
            name: target.files[0].name,
            type: target.files[0].type,
            uri: URL.createObjectURL(target.files[0]),
          })
        }
      />
    </label>
  );
}

export { FileInput };
